import { registerSounds } from '@/vue/features/shared/sound/services/soundRegistry';
import { ringtoneMap } from '../sound/ringtoneMap';

let isRegistered = false;

export const registerCueSounds = (): void => {
    if (isRegistered) {
        return;
    }

    registerSounds(ringtoneMap);

    isRegistered = true;
};
